import FinancialsPanel from 'scripts/components/shared/FinancialsPanel';
import { property as propertyPropType } from 'scripts/constants/PropTypes';
import { capitalize, dollar } from 'scripts/utilities/formatters';
import InvestmentTypes from 'src/enums/investmentTypes';
import { loanAdvanceDetails } from 'src/settings/financials';

const DebtBreakdown = ({ property }) => {
  const isGeared = property.financials.gearingEffect > 0;
  const isFixedTerm =
    isGeared && property.financials.debtTerms.fixedLoanTerms > 0;
  return (
    <FinancialsPanel
      className="debt-breakdown-panel"
      title={
        property.investmentType === InvestmentTypes.mortgage
          ? 'Loan Advance'
          : 'Debt Breakdown'
      }
    >
      <div className="row my-row">
        <div className="col-xs-7 col-no-padding-right bold">
          {property.investmentType === InvestmentTypes.mortgage
            ? 'Initial Loan Advance'
            : 'Initial Debt'}
        </div>
        <div className="col-xs-5 col-no-padding-left text-right initial-debt">
          {property.investmentType === InvestmentTypes.mortgage
            ? property.financials.loanAdvance::dollar()
            : isGeared
              ? property.financials.debtTerms.initialDebt::dollar()
              : '$0'}
        </div>
      </div>
      <div className="gray-line" />
      <div className="row my-row">
        <div className="col-xs-7 col-no-padding-right bold">Loan Terms</div>
        <div className="col-xs-5 col-no-padding-left text-right loan-terms">
          {property.investmentType === InvestmentTypes.mortgage
            ? loanAdvanceDetails[property.propertyCode].loanTerms
            : isGeared
              ? `${property.financials.debtTerms.loanTerms} Years`
              : '0 Year'}
        </div>
      </div>
      <div className="gray-line" />
      <div className="row my-row">
        <div className="col-xs-7 col-no-padding-right bold">Loan Type</div>
        <div className="col-xs-5 col-no-padding-left text-right loan-term-type">
          {property.investmentType === InvestmentTypes.mortgage
            ? loanAdvanceDetails[property.propertyCode].loanType
            : isGeared
              ? property.financials.debtTerms.loanTermType::capitalize()
              : 'NA'}
        </div>
      </div>
      <div className="gray-line" />
      <div className="row my-row">
        <div className="col-xs-6 col-no-padding-right bold">
          {property.investmentType === InvestmentTypes.mortgage
            ? 'Rate Terms'
            : 'Fixed Terms'}
        </div>
        <div className="col-xs-6 col-no-padding-left text-right fixed-terms">
          {property.investmentType === InvestmentTypes.mortgage
            ? loanAdvanceDetails[property.propertyCode].rateTerms
            : isFixedTerm
              ? `${property.financials.debtTerms.fixedLoanTerms} Years (Interest Only)`
              : 'NA'}
        </div>
      </div>
      <div className="gray-line" />
      <div className="row my-row">
        <div className="col-xs-7 col-no-padding-right bold">
          {property.investmentType === InvestmentTypes.mortgage
            ? 'Interest Rate Target'
            : 'Interest Rate'}
        </div>
        <div className="col-xs-5 col-no-padding-left text-right interest-rate">
          {property.investmentType === InvestmentTypes.mortgage
            ? loanAdvanceDetails[property.propertyCode].interestRateTarget
            : isGeared
              ? `${property.financials.debtTerms.interestRatePerc}%`
              : '0%'}
        </div>
      </div>
      <div className="gray-line" />
      {property.investmentType === InvestmentTypes.mortgage ? (
        <div className="row my-row">
          <div className="col-xs-7 col-no-padding-right bold">
            Property Security
          </div>
          <div className="col-xs-5 col-no-padding-left text-right">
            {loanAdvanceDetails[property.propertyCode].propertySecurity}
          </div>
        </div>
      ) : (
        <div className="row my-row note">
          <div className="col-md-12">
            Note:{' '}
            {isGeared
              ? `${property.financials.debtTerms.loanDescription}`
              : 'NA'}
          </div>
        </div>
      )}
    </FinancialsPanel>
  );
};

DebtBreakdown.propTypes = {
  property: propertyPropType.isRequired,
};

export default DebtBreakdown;
